import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  const columns = [
    {
      title: t.footer.platform,
      links: [
        { label: t.footer.platformLinks[0], to: "/#how-it-works", id: "how" },
        { label: t.footer.platformLinks[1], to: "/#calculator", id: "calc" },
        { label: t.footer.platformLinks[2], to: "/#specs", id: "specs" },
      ],
    },
    {
      title: t.footer.brands,
      links: [
        { label: t.footer.brandsLinks[0], to: "/brands", id: "brands" },
        { label: t.footer.brandsLinks[1], to: "/brands", id: "targeting" },
        { label: t.footer.brandsLinks[2], to: "/#contact", id: "request" },
      ],
    },
    {
      title: t.footer.people,
      links: [
        { label: t.footer.peopleLinks[0], to: "/#register", id: "register" },
        { label: t.footer.peopleLinks[1], to: "/people", id: "earnings" },
        { label: t.footer.peopleLinks[2], to: "/people", id: "rules" },
      ],
    },
    {
      title: t.footer.company,
      links: [
        { label: t.footer.companyLinks[0], to: "/about", id: "about" },
        { label: t.footer.companyLinks[1], to: "/#contact", id: "contact" },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { label: t.footer.legalLinks[0], to: "/impressum", id: "impressum" },
        { label: t.footer.legalLinks[1], to: "/datenschutz", id: "datenschutz" },
        { label: t.footer.legalLinks[2], to: "/agb", id: "agb" },
        { label: t.footer.legalLinks[3], to: "/datenschutz#cookies", id: "cookies" },
      ],
    },
  ];

  return (
    <footer className="bg-slate-950 text-slate-500 border-t border-slate-800 py-12 text-xs font-mono-spec" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 pb-10 border-b border-slate-800/60">
          <div className="col-span-2 sm:col-span-3 lg:col-span-1">
            <div data-testid="footer-logo">
              <Logo dark markClass="w-6 h-6 text-blue-500" textClass="text-base" showTagline />
            </div>
            <p className="text-slate-500 mt-3 leading-relaxed" data-testid="footer-tagline">{t.footer.tagline}</p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <div className="text-slate-300 font-semibold mb-3 uppercase tracking-wider">{col.title}</div>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.id}>
                    {link.to ? (
                      <Link to={link.to} data-testid={`footer-link-${link.id}`} className="text-slate-500 hover:text-white transition-colors">
                        {link.label}
                      </Link>
                    ) : (
                      <span data-testid={`footer-link-${link.id}`} className="text-slate-600 cursor-default">
                        {link.label}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="pt-6 flex flex-col sm:flex-row justify-between gap-2 text-slate-600">
          <span>{t.footer.bottom}</span>
          <span>Lidlink — advertising on the devices people carry.</span>
        </div>
      </div>
    </footer>
  );
}
